<app-line-details
  [line]="line"
  [showLineCity]="true"
  [isAutoComplete]="true"
  [isPointer]="isPointer"
  (onLineClick)="onResultClick.emit($event)"
  (onAgencyClick)="onAgencyClick.emit($event)" />
<mat-divider class="!mt-2" />